/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select a specific confirmed order that is done
 * @param {any} state The state management `state`
 * @returns {OrderEntity | null} The `confirmed order that is done` which has been selected from the store
 */
const orderConfirmationDoneSelector = createSelector(ordersSelector, (orders) => orders.orderConfirmationDone);

export default orderConfirmationDoneSelector;
